export default "__VITE_ASSET__4N9z3GYC__"